import { Skeleton, VStack } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { InvoiceSummaryFragmentGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { InvoiceConsolidatedDisbursementsTable } from './InvoiceConsolidatedDisbursementsTable';
import { Typography } from 'packages/common-frontend/components/Typography';
import { useGetInvoiceConsolidatedDisbursementsByInvoiceIdQuery } from 'packages/invoices/requests/invoices.gql.generated';

export const InvoiceConsolidatedDisbursements = ({
  invoice,
}: {
  invoice: InvoiceSummaryFragmentGQLType;
}) => {
  const {
    data: invoiceConsolidatedDisbursementsData,
    loading: isInvoiceConsolidatedDisbursementsLoading,
  } = useGetInvoiceConsolidatedDisbursementsByInvoiceIdQuery({
    variables: { invoiceId: invoice.id },
    fetchPolicy: 'network-only',
  });

  if (
    isInvoiceConsolidatedDisbursementsLoading ||
    !invoiceConsolidatedDisbursementsData
  ) {
    return <Skeleton height="200px" />;
  }

  if (
    invoiceConsolidatedDisbursementsData
      .getInvoiceConsolidatedDisbursementsByInvoiceId.length === 0
  ) {
    return null;
  }

  const sortedDisbursements = _.sortBy(
    invoiceConsolidatedDisbursementsData.getInvoiceConsolidatedDisbursementsByInvoiceId,
    (disbursement) => disbursement.capitalProviderOrganization.name,
  );

  return (
    <VStack align="flex-start" gap="40px" width="100%">
      <Typography fontWeight="bold">Disbursements</Typography>
      <InvoiceConsolidatedDisbursementsTable
        consolidatedDisbursements={sortedDisbursements}
        invoiceReports={invoice.invoiceReports ?? undefined}
        invoice={invoice}
      />
    </VStack>
  );
};
